export const getInt = (s: string) => {
    try {
        if (!s) return 0;
        if (s == 'N/A') return 0;

        return parseInt(
            s
                .toString()
                .match(/(-)?\d+[\.,\d+]*/)[0]
                .replace(',', '')
        );
    } catch (e) {
        return 0;
    }
};

export const getFloat = (s: string) => {
    try {
        if (!s) return 0;
        if (s == 'N/A') return 0;

        return parseFloat(
            s
                .toString()
                .match(/(-)?\d+[\.,\d+]*/)[0]
                .replace(',', '')
        );
    } catch (e) {
        return 0;
    }
};

export const isFloat = (s: string) => {
    try {
        if (!s) return false;
        if (s == 'N/A') return false;

        return !isNaN(parseFloat(s.match(/\d+[\.,\d+]*/)[0]));
    } catch (e) {
        return false;
    }
};
export const isInt = (s: string) => {
    try {
        if (!s) return false;
        if (s == 'N/A') return false;

        return !isNaN(parseInt(s.toString().match(/\d+[\.,\d+]*/)[0]));
    } catch (e) {
        return false;
    }
};

function isString(s: any) {
    return typeof s === 'string' || s instanceof String;
}

export type MaxSize = 'M' | 'B' | 'auto';
const EMPTY_RETURN = '-';

export const formatDollarStr = (
    s: string,
    sizeConversion: MaxSize = 'auto'
) => {
    function formatNumberCommas(num) {
        return num
            .toFixed(1)
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    if (!s || s == 'N/A' || s == 'NaN') {
        return EMPTY_RETURN;
    }

    if (isString(s)) {
        var str = s as string;
        if (str == '' || str == 'N/A' || str == 'NaN') return EMPTY_RETURN;
        if (isFloat(str)) {
            var num = getFloat(str);
            var absNum = Math.abs(num);
            var letterToAdd = '';

            //Values expected in MILLIONS
            if (sizeConversion === 'auto') {
                if (absNum != 0) {
                    if (absNum > 1000) {
                        letterToAdd = 'B';
                        num = num / 1000;
                    } else if (absNum < 1) {
                        num = num * 1000;
                        letterToAdd = 'K';
                    }
                }
            }

            var numDisplay = formatNumberCommas(Math.abs(num)) + letterToAdd;

            if (num >= 0) {
                return '$' + numDisplay;
            } else {
                return '-$' + numDisplay;
            }
        } else {
            return EMPTY_RETURN;
        }
    } else {
        return EMPTY_RETURN;
    }
};

export const formatPercentStr = (s: string, multiplyBy: number = 100) => {
    if (!s) {
        return EMPTY_RETURN;
    }

    if (isString(s)) {
        var str = s as string;
        if (str == '' || str == 'N/A') return EMPTY_RETURN;
        if (isFloat(str)) {
            var num = getFloat(str);
            var r = (num * multiplyBy).toFixed(1) + '%';

            return r;
        } else {
            return EMPTY_RETURN;
        }
    } else {
        return EMPTY_RETURN;
    }
};

/**
 * Removes query parameters from a URL (everything after '?')
 * Example: https://www.abacenters.com/about-us/?psafe_param=1&utm_source=google&... → https://www.abacenters.com/about-us/
 */
export const removeUrlQueryParams = (url: string): string => {
    if (!url) return url;
    return url.split('?')[0];
};
